/*! @azure/msal-browser v3.30.0 2025-08-05 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.30.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
